import { Field } from 'formik'
import styled from 'styled-components'
import { P, Button as Submit } from 'ui/bend'
import React from 'react'

export const Main = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px;
  background-color: #f4f7fb;
  border-radius: 12px;

  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  button {
    outline: none;
  }
  .flex-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    button {
      border-radius: 6px !important;
    }
  }

  .btn {
    border-radius: 4px !important;
  }
  .section-item {
    background-color: #f4f7fb;
    padding: 12px;
    border-radius: 12px;
  }
  .remove-button-col {
    display: flex;
    align-self: center;
    padding-top: 0.5rem;
  }
  .submit-box {
    margin-top: 24px;
  }
  .section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .align-items-center {
    display: grid;
    gap: 16px;
    margin: 8px 0;
    grid-template-columns: repeat(auto-fill, minmax(min(200px, 100%), 1fr));
    label {
      margin-bottom: 5px;
    }
    &.title-row {
      margin-bottom: 16px;
    }
  }
  .remove-item {
    button {
      width: fit-content;
      margin-top: 12px;
    }
  }
  .section {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  .section-title-row {
    margin-bottom: 16px;
  }
  .section-item-actions {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: wrap;

    .up,
    .down {
      padding: 6px;
      border: none;
      color: white;
      text-align: center;
      text-decoration: none;
      cursor: pointer;
      outline: none;
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .up svg {
      transform: rotate(90deg);
    }
    .down svg {
      transform: rotate(270deg);
    }
    .move-field {
      select {
        padding: 4px;
      }
    }
  }
`

const DragButton = styled.button`
  cursor: move;
  padding: 8px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  outline: none;
  height: 35px;
  width: 35px;
`

export const DragButtonComponent = (props) => (
  <DragButton type='button' className='section-handle' {...props}>
    <svg
      className='codicon codicon-drag-handle'
      viewBox='0 0 21 34'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <defs></defs>
      <g
        id='Page-1'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g id='Group-39' fill='#D8D8D8'>
          <rect
            id='Rectangle-39'
            x='0.0185594424'
            y='0.915122915'
            width='6.66666667'
            height='6.66666667'
          ></rect>
          <rect
            id='Rectangle-39-Copy-6'
            x='0.0185594424'
            y='14.1176497'
            width='6.66666667'
            height='6.66666667'
          ></rect>
          <rect
            id='Rectangle-39-Copy-10'
            x='0.0185594424'
            y='27.3201765'
            width='6.66666667'
            height='6.66666667'
          ></rect>
          <rect
            id='Rectangle-39-Copy-2'
            x='13.3518928'
            y='0.915122915'
            width='6.66666667'
            height='6.66666667'
          ></rect>
          <rect
            id='Rectangle-39-Copy-8'
            x='13.3518928'
            y='14.1176497'
            width='6.66666667'
            height='6.66666667'
          ></rect>
          <rect
            id='Rectangle-39-Copy-14'
            x='13.3518928'
            y='27.3201765'
            width='6.66666667'
            height='6.66666667'
          ></rect>
        </g>
      </g>
    </svg>
  </DragButton>
)

export const SectionWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding: 25px;
  min-height: 100px;
`

export const SectionHeader = styled.h4`
  color: #333;
  font-size: 16px;
  margin-bottom: 15px;
  font-weight: 600;
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Input = styled(Field)`
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  transition: border 0.2s ease;

  &:focus {
    border-color: #007bff;
    outline: none;
  }
`

export const Select = styled.select`
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  transition: border 0.2s ease;

  &:focus {
    border-color: #007bff;
    outline: none;
  }
`

export const Label = styled.label`
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
`

export const AddButton = styled.button`
  padding: 12px 20px;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  outline: none;
`

export const RemoveButton = styled(AddButton)`
  &.section,
  &.collapse-button {
    width: 30px;
    height: 30px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    background: rgba(0, 0, 0, 0.1);
    &:hover {
      background: rgba(0, 0, 0, 0.2);
    }
    &.closed svg {
      transform: rotate(180deg);
      transition: transform 0.25s ease-in-out;
    }
    &.opened svg {
      transform: rotate(270deg);
      transition: transform 0.25s ease-in-out;
    }
  }
  &.section {
    padding: 6px;
  }
  &.section-delete {
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
  }
`

export const SubmitButton = styled(Submit)`
  background-color: #28a745;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: #218838;
  }

  &:focus {
    outline: none;
  }
`

export const SuccessMessage = styled(P)`
  color: #28a745;
  font-weight: 600;
  margin-top: 15px;
`
export const ErrorMessage = styled(P)`
  color: #c82333;
  font-weight: 500;
  margin-top: 15px;
`
